export default {
  setSearchParam(context, payload) {
    context.commit('setSearchParam', payload);
  },
  setStores(context, payload) {
    context.commit('setStores', payload);
  },
  setApi(context, payload) {
    context.commit('setApi', payload);
  },
  setLocation(context, payload) {
    context.commit('setLocation', payload);
  },
  setSyncedInputValues(context, payload) {
    context.commit('setSyncedInputValues', payload);
  }
};

